export const USED_AS_SPA = "false" === 'true';
export const SENTRY_DSN = "https://fc9ce39698243c64d0b6d9bf2ebf3774@o61655.ingest.us.sentry.io/4507774680891392" || '';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_STAGING = "n33vr9vfs09671pc90pgi7kvj8q7vvvfvjvd";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_PRODUCTION = "9a44abjpf5r66aq6r9o6426v9n2tg9ko9tah";
export default environment => {
  switch (environment) {
    case 'TEST':
    case 'LOCAL':
    case 'DEVELOPMENT':
    case 'STAGING':
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_STAGING,
        urls: {
          MAIN_APP: 'https://www.datacamp-staging.com'
        }
      };
    case 'PRODUCTION':
    default:
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_PRODUCTION,
        urls: {
          MAIN_APP: 'https://www.datacamp.com'
        }
      };
  }
};